// Figma radiusComponentInputMedium (8px) — not exported from @calendly/ui/theme

export const mainContentCss = "m1glmer2";
export const pageHeaderCss = "pzx3me8";
export const settingsCss = "sq7puvm";
export const sectionCss = "s1vd8xfn";
export const sectionHeaderCss = "s1d2m6sj";
export const eventTypeLimitsSubsectionCss = "eqao1a0";
export const dividerCss = "d1r91cgu";
export const bufferRowCss = "b1094hbo";
export const selectFieldCss = "sm6dvrd";
export const limitsCardCss = "l1p608f5";
export const limitsRowCss = "l1twotvh";
export const limitsRowEnabledCss = "lvpy9jk";
export const limitsRowDisabledCss = "l1gionxq";
export const limitsRowSwitchGroupCss = "l19nzpgt";
export const limitsRowSwitchInputWrapCss = "l124n40o";
export const limitsRowSwitchLabelCss = "lc5hfe";
export const limitsRowValueCss = "lz3cv8p";
export const limitsRowNumberInputCss = "l1jjneiu";
export const limitsRowStatusCss = "l1xylo6d";
export const globalLimitsCardCss = "ggmcc1l";
export const globalLimitsUserCss = "g1tfuhko";
export const globalLimitsUserTextCss = "g1pjkmmm";

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");